import { cn } from "@/lib/utils";

// Fixed hue per format. Same mapping used everywhere.
const FORMAT_HUE: Record<string, number> = {
  "Film (Feature)": 250, // blue
  Film: 250,
  TV: 150, // green
  Commercial: 70, // amber
  "Short Film": 305, // purple
  Theatre: 20, // warm
  Voiceover: 195, // teal
};

const DEFAULT_HUE = 240;

export function getFormatHue(format?: string | null): number {
  if (!format) return DEFAULT_HUE;
  return FORMAT_HUE[format] ?? DEFAULT_HUE;
}

export interface FormatBadgeProps {
  format?: string | null;
  className?: string;
}

export function FormatBadge({ format, className }: FormatBadgeProps) {
  if (!format) return null;
  const hue = getFormatHue(format);

  return (
    <span
      style={{ ["--fmt-h" as string]: String(hue) }}
      className={cn(
        "format-badge inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] font-medium leading-none whitespace-nowrap",
        className,
      )}
    >
      {format}
    </span>
  );
}
